<div class="pkt-toggle-wrapper">
  <mat-slide-toggle [checked]="value" [disabled]="disabled" [labelPosition]="labelPosition" [color]="color"
    (change)="onToggleChange($event.checked)">
    <span class="pkt-toggle-label" *ngIf="label">{{ label }}</span>
  </mat-slide-toggle>
  <span *ngIf="statusLabel" class="pkt-status-label">{{ statusLabel }}</span>
  <span *ngIf="hint" class="pkt-hint">{{ hint }}</span>
</div>